export const AccountTypes = [
  { label: "Conta corrente", value: "CHECKING_ACCOUNT" },
  { label: "Conta poupança", value: "SAVINGS_ACCOUNT" }
]